<template>
  <section class="analysis-page clipr-theme twitch-theme">
    <div class="analysis-card">
      <div class="analysis-orbit analysis-orbit--one"></div>
      <div class="analysis-orbit analysis-orbit--two"></div>

      <div class="analysis-icon" aria-hidden="true">
        <i class="fa-solid fa-chart-line"></i>
      </div>

      <span class="analysis-status">{{ tt("analysis.status", "BAJO CONSTRUCCIÓN") }}</span>
      <h1>{{ tt("analysis.title", "Análisis en camino") }}</h1>
      <p>{{ tt("analysis.description", "Muy pronto podrás entender el rendimiento de tus clips y descubrir qué contenido funciona mejor.") }}</p>

      <div class="analysis-preview" aria-hidden="true">
        <div class="analysis-preview-chart">
          <span class="analysis-preview-line"></span>
          <span class="analysis-preview-dot analysis-preview-dot--one"></span>
          <span class="analysis-preview-dot analysis-preview-dot--two"></span>
          <span class="analysis-preview-dot analysis-preview-dot--three"></span>
        </div>
        <div class="analysis-preview-bars">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Analysis",
  methods: {
    tt(key, fallback) {
      return typeof this.$t === "function" ? this.$t(key) : fallback;
    },
  },
};
</script>

<style scoped>
.analysis-page {
  display: grid;
  min-height: calc(100vh - 90px);
  place-items: center;
  padding: 28px 24px 48px;
}

.analysis-card {
  position: relative;
  width: min(100%, 740px);
  overflow: hidden;
  padding: 58px 46px 42px;
  border: 1px solid rgba(196, 181, 253, 0.25);
  border-radius: 24px;
  background:
    radial-gradient(circle at 15% 15%, rgba(34, 211, 238, 0.12), transparent 30%),
    radial-gradient(circle at 85% 90%, rgba(168, 85, 247, 0.17), transparent 35%),
    rgba(15, 23, 42, 0.82);
  box-shadow: 0 28px 70px rgba(0, 0, 0, 0.35), inset 0 1px 0 rgba(255, 255, 255, 0.06);
  text-align: center;
}

.analysis-orbit {
  position: absolute;
  width: 340px;
  height: 340px;
  border: 1px solid rgba(167, 139, 250, 0.16);
  border-radius: 50%;
  pointer-events: none;
}

.analysis-orbit--one {
  top: -210px;
  right: -125px;
}

.analysis-orbit--two {
  bottom: -280px;
  left: -120px;
  width: 420px;
  height: 420px;
}

.analysis-icon {
  position: relative;
  display: inline-flex;
  width: 72px;
  height: 72px;
  align-items: center;
  justify-content: center;
  margin-bottom: 18px;
  border: 1px solid rgba(196, 181, 253, 0.34);
  border-radius: 20px;
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.3), rgba(34, 211, 238, 0.18));
  color: #ddd6fe;
  font-size: 30px;
  box-shadow: 0 12px 28px rgba(139, 92, 246, 0.22);
}

.analysis-status {
  position: relative;
  display: table;
  margin: 0 auto 12px;
  padding: 6px 9px;
  border: 1px solid rgba(103, 232, 249, 0.28);
  border-radius: 999px;
  background: rgba(6, 182, 212, 0.1);
  color: #a5f3fc;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.1em;
}

.analysis-card h1 {
  position: relative;
  margin: 0;
  color: var(--clipr-text-primary, #f8fafc);
  font-size: clamp(28px, 5vw, 42px);
  font-weight: 800;
  letter-spacing: -0.04em;
}

.analysis-card p {
  position: relative;
  max-width: 510px;
  margin: 12px auto 28px;
  color: var(--clipr-text-muted, #94a3b8);
  font-size: 15px;
  line-height: 1.6;
}

.analysis-preview {
  position: relative;
  display: grid;
  grid-template-columns: 1.4fr 0.6fr;
  gap: 20px;
  padding: 18px;
  border: 1px solid rgba(148, 163, 184, 0.13);
  border-radius: 16px;
  background: rgba(2, 6, 23, 0.34);
}

.analysis-preview-chart {
  position: relative;
  height: 82px;
  overflow: hidden;
  border-bottom: 1px solid rgba(148, 163, 184, 0.2);
  background: repeating-linear-gradient(
    to bottom,
    transparent 0,
    transparent 20px,
    rgba(148, 163, 184, 0.08) 21px
  );
}

.analysis-preview-line {
  position: absolute;
  right: 4%;
  bottom: 17px;
  left: 4%;
  height: 2px;
  transform: skewY(-12deg);
  transform-origin: left;
  background: linear-gradient(90deg, #8b5cf6, #22d3ee);
  box-shadow: 0 0 14px rgba(34, 211, 238, 0.6);
}

.analysis-preview-dot {
  position: absolute;
  width: 7px;
  height: 7px;
  border: 2px solid #0f172a;
  border-radius: 50%;
  background: #67e8f9;
  box-shadow: 0 0 10px rgba(103, 232, 249, 0.7);
}

.analysis-preview-dot--one {
  bottom: 34px;
  left: 29%;
}

.analysis-preview-dot--two {
  bottom: 24px;
  left: 54%;
}

.analysis-preview-dot--three {
  right: 10%;
  bottom: 12px;
}

.analysis-preview-bars {
  display: flex;
  height: 82px;
  align-items: end;
  justify-content: space-between;
  gap: 5px;
}

.analysis-preview-bars span {
  width: 100%;
  border-radius: 4px 4px 1px 1px;
  background: linear-gradient(180deg, rgba(34, 211, 238, 0.85), rgba(139, 92, 246, 0.34));
}

.analysis-preview-bars span:nth-child(1) { height: 32%; }
.analysis-preview-bars span:nth-child(2) { height: 57%; }
.analysis-preview-bars span:nth-child(3) { height: 45%; }
.analysis-preview-bars span:nth-child(4) { height: 76%; }
.analysis-preview-bars span:nth-child(5) { height: 92%; }

@media (max-width: 560px) {
  .analysis-page {
    padding-right: 12px;
    padding-left: 12px;
  }

  .analysis-card {
    padding: 42px 22px 24px;
  }

  .analysis-preview {
    grid-template-columns: 1fr;
  }

  .analysis-preview-bars {
    display: none;
  }
}
</style>
